import '@babel/polyfill';
import 'raf/polyfill';
import React from 'react';
import ReactDom from 'react-dom';
import './reset.css';
import Layout from './layout/';

/* eslint-disable no-undef */
ReactDom.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable no-undef */
